// DS: DEV6
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import CloseIconBold from '@wix/da-ds/pkg/Icons/CloseBold';
import IconButton from '../../../Button/IconButton';
import s from './PopoverCard.scss';
export const PopoverCard = ({ className, closeButtonClassName, withCloseButton = true, onClose, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(ThemeOverride, {
        className: s['theme-wrapper'],
        theme: ThemeOptions.LIGHT
    }, withCloseButton && /*#__PURE__*/ React.createElement(IconButton, {
        className: c(s['close-button'], closeButtonClassName),
        onClick: onClose,
        noHoverEffect: true
    }, /*#__PURE__*/ React.createElement(CloseIconBold, null)), children));
};
PopoverCard.displayName = 'PopoverCard';
export default PopoverCard;
